<template>
    <div>
        <div id="modalSaveProposalTemplateGroup" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            {{ proposalTemplateGroupModalTitle }}
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                @click="cancelModalProposalTemplateGroup()"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalTemplateGroupName"
                                            id="proposal_template_group_name">
                                </div>
                                <span id="proposal_template_group_name_error" style="color:red;"><small>{{proposalTemplateGroupNameError}}</small></span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="proposalTemplateGroupModalButton == 'Save'" id="save-proposal-type" name="save-proposal-type"
                                @click="saveProposalTemplateGroup()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            {{ proposalTemplateGroupModalButton }}
                        </button>
                        <button v-if="proposalTemplateGroupModalButton == 'Update'" id="update-proposal-type" name="update-proposal-type"
                                @click="updateProposalTemplateGroupName()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            {{ proposalTemplateGroupModalButton }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="templateModal" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Rename Proposal Content
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                @click="cancelModalProposalTemplateRename()"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalTemplateName"
                                            id="proposal_template_name">
                                </div>
                                <span id="proposal_template_name_error" style="color:red;"><small>{{proposalTemplateNameError}}</small></span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="update-proposal-template" name="update-proposal-template"
                                @click="updateProposalTemplateName()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="addTemplateToProposalTemplateGroupModal" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Add/Remove Content to Proposal Section Content
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                @click="cancelModalProposalTemplateGroup()"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <multiselect
                                        id="proposalTemplateGroupListing"
                                        v-model="selectedProposalTemplateGroupListing"
                                        :options="proposalTemplateGroupList"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Pick Proposal Section Content"
                                        :showLabels="false"
                                        label="name"
                                        track-by="id"
                                        :preselect-first="false"
                                        :disabled="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="mb-2">
                                <div class="form-group">
                                    <multiselect
                                        id="allProposalTemplates"
                                        v-model="selectedProposalTemplateListing"
                                        :options="allProposalTemplates"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Pick Proposal Content"
                                        :showLabels="false"
                                        label="template_name"
                                        track-by="id"
                                        :preselect-first="false"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button name="save-proposal-type"
                                @click="saveProposalTemplateToGroup()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="12">
                    <b-card-group deck>
                        <b-card header="Proposal Section Contents" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="12">
                                        <div>
                                            <div class="proposal-type-buttons">
                                                <div class="flex-1 text-left float-left">
                                                    <b-dropdown id="proposal-template-group-setting" dropright :text="proposalTemplateGroupDropdownTitle" variant="outline-danger" class="m-md-2" style="margin-left: 0 !important;">
                                                        <span v-if="proposalTemplateGroupList.length > 0">
                                                            <span v-for="proposalTemplateGroup in proposalTemplateGroupList" class="proposal-type-head-span">
                                                                <b-dropdown-item @click="selectProposalTemplateGroup(proposalTemplateGroup)"><span class="proposal-type-name-span">{{proposalTemplateGroup.name}}</span></b-dropdown-item>
                                                                <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" @click.prevent=""
                                                                        aria-expanded="false">
                                                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        </svg>
                                                                    </button>
                                                                    <div class="dropdown-menu">
                                                                        <a class="dropdown-item" @click="openRenameModal(proposalTemplateGroup)">Rename</a>
                                                                        <a class="dropdown-item" @click="deleteProposalTemplateGroup(proposalTemplateGroup)">Delete</a>
                                                                        <a class="dropdown-item" @click="copyProposalTemplateGroup(proposalTemplateGroup)">Make Copy</a>
                                                                    </div>
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            <b-dropdown-item class="dropdownCustomItem">No proposal section content has been created yet.</b-dropdown-item>
                                                        </span>
                                                    </b-dropdown>
                                                </div>
                                                <div class="flex-1 text-right float-right mt-2">
                                                    <input @click="openModalSaveProposalTemplateGroup()" type="button" class="btn btn-primary" value="Add new section content" />
                                                </div>
                                                <div v-if="selectedProposalTemplateGroup" class="flex-1 text-right float-right mt-2 mr-4">
                                                    <input @click="updateProposalTemplateGroup()" type="button" class="btn btn-primary" value="Update section content" />
                                                </div>
                                                <div class="proposal-type-sections-div d-inline-block w-100" v-if="selectedProposalTemplateGroup">
                                                    <div class="mt-4" v-if="allProposalTemplateListing.length > 0">
                                                        <div v-for="singleProposalTemplateListing in allProposalTemplateListing">
                                                            <div class="template-single mb-2">
                                                                <span class="tempName" :title="singleProposalTemplateListing.template_name">{{singleProposalTemplateListing.template_name}}</span>
                                                                <button type="button" :id="'dropdownMenu'+singleProposalTemplateListing.id" data-toggle="dropdown" aria-haspopup="true" @click.prevent=""
                                                                        aria-expanded="false" class="menuDots">
                                                                    <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                                                         viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        <path
                                                                            d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        <path
                                                                            d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                    </svg>
                                                                </button>
                                                                <div class="dropdown-menu">
                                                                    <a class="dropdown-item" @click="renameTemplateModal(singleProposalTemplateListing)">Rename</a>
                                                                    <a class="dropdown-item" @click="deleteTemplate(singleProposalTemplateListing)">Delete</a>
                                                                    <a class="dropdown-item" @click="copyTemplate(singleProposalTemplateListing)">Make Copy</a>
                                                                    <a class="dropdown-item" @click="removeTemplateFromGroup(singleProposalTemplateListing)">Remove from Group</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-4" v-else>
                                                        No content added in this proposal section content.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Multiselect from "vue-multiselect";
import Swatches from "vue-swatches";
import Form from "../../utils/form";

export default {
    name: "proposal-template-group",
    components: {Multiselect},
    props:['proposalTemplateGroups','team'],
    data() {
        return {
            proposalTemplateGroupDropdownTitle: 'Select Section Content',
            proposalTemplateGroupModalTitle: '',
            proposalTemplateGroupModalButton: '',
            proposalTemplateGroupName: '',
            proposalTemplateGroupNameError: '',
            selectedProposalTemplateGroup: null,
            proposalTemplateGroupList: this.proposalTemplateGroups,
            selectedProposalTemplateGroupListing:[],
            allProposalTemplates:[],
            selectedProposalTemplateListing:[],
            allProposalTemplateListing:[],
            proposalTemplateName: '',
            proposalSelectedTemplate: null,
            proposalTemplateNameError: '',
        };
    },
    mounted(){

    },
    methods: {
        openModalSaveProposalTemplateGroup(){
            this.proposalTemplateGroupModalTitle = 'Proposal Section Content Name';
            this.proposalTemplateGroupModalButton = 'Save';
            $('#modalSaveProposalTemplateGroup').modal("show");
        },
        saveProposalTemplateGroup(){
            if(this.proposalTemplateGroupName.trim() == '' || this.proposalTemplateGroupName == null){
                this.fireErrorToast('Please enter proposal section content name.');
                this.proposalTemplateGroupName = '';
                return false;
            }
            axios.post(route('api.proposal-template-group.store'), {name:this.proposalTemplateGroupName}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.cancelModalProposalTemplateGroup();
                    this.selectProposalTemplateGroup(data.proposalTemplateGroup);
                    this.proposalTemplateGroupList = data.listProposalTemplateGroups;
                    this.selectedProposalTemplateGroupListing = data.proposalTemplateGroup;
                    this.fetchAllTemplates(data.proposalTemplateGroup);
                    $('#addTemplateToProposalTemplateGroupModal').modal("show");
                }else{
                    this.fireErrorToast(data.message);
                    $('#proposal_template_group_name').css('border', "1px solid red");
                    this.proposalTemplateGroupNameError = data.message;
                }
            });
        },
        cancelModalProposalTemplateGroup(){
            this.proposalTemplateGroupModalTitle = '';
            this.proposalTemplateGroupModalButton = '';
            this.proposalTemplateGroupName = '';
            this.proposalTemplateGroupNameError = '';
            $('#proposal_template_group_name').removeAttr("style");
            $('#modalSaveProposalTemplateGroup').modal("hide");
        },
        selectProposalTemplateGroup(proposalTemplateGroup){
            this.proposalTemplateGroupDropdownTitle = proposalTemplateGroup.name;
            this.selectedProposalTemplateGroup = proposalTemplateGroup;
            this.fetchAllTemplates(proposalTemplateGroup);
        },
        fetchAllTemplates(proposalTemplateGroup){
            axios.post(route('api.proposal-template-group.all-templates'), {proposalTemplateGroup:proposalTemplateGroup}).then(({data}) => {
                if(data.status == 'success'){
                    this.allProposalTemplates = data.templates;
                    this.selectedProposalTemplateListing = data.selectedTemplates;
                    this.allProposalTemplateListing = data.selectedTemplates;
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        saveProposalTemplateToGroup(){
            axios.post(route('api.proposal-template-group.add-templates'), {proposalTemplateGroup:this.selectedProposalTemplateGroup, templates:this.selectedProposalTemplateListing}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.allProposalTemplateListing = data.selectedTemplates;
                    $('#addTemplateToProposalTemplateGroupModal').modal("hide");
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        updateProposalTemplateGroup(){
            this.fetchAllTemplates(this.selectedProposalTemplateGroup);
            this.selectedProposalTemplateGroupListing = this.selectedProposalTemplateGroup;
            $('#addTemplateToProposalTemplateGroupModal').modal("show");
        },
        openRenameModal(proposalTemplateGroup){
            this.proposalTemplateGroupModalTitle = 'Proposal Section Content Name';
            this.proposalTemplateGroupModalButton = 'Update';
            this.selectProposalTemplateGroup(proposalTemplateGroup);
            this.proposalTemplateGroupName = proposalTemplateGroup.name;
            $('#modalSaveProposalTemplateGroup').modal("show");
        },
        updateProposalTemplateGroupName(){
            if(this.proposalTemplateGroupName.trim() == '' || this.proposalTemplateGroupName == null){
                this.fireErrorToast('Please enter proposal section content name.');
                this.proposalTemplateGroupName = '';
                return false;
            }
            axios.post(route('api.proposal-template-group.rename'), {name:this.proposalTemplateGroupName, proposalTemplateGroup: this.selectedProposalTemplateGroup}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.cancelModalProposalTemplateGroup();
                    this.selectProposalTemplateGroup(data.proposalTemplateGroup);
                    this.proposalTemplateGroupList = data.listProposalTemplateGroups;
                    this.selectedProposalTemplateGroupListing = data.proposalTemplateGroup;
                    this.fetchAllTemplates(data.proposalTemplateGroup);
                }else{
                    this.fireErrorToast(data.message);
                    $('#proposal_template_group_name').css('border', "1px solid red");
                    this.proposalTemplateGroupNameError = data.message;
                }
            });
        },
        deleteProposalTemplateGroup(proposalTemplateGroup){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal section content!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-template-group.delete'), {proposalTemplateGroup: proposalTemplateGroup}).then(({data}) => {
                        if(data.status == 'success'){
                            this.fireSuccessToast(data.message);
                            window.open(route('settings.team', {tab: 'proposal-content-group',team:this.team.id}),'_self');

                        }else{
                            this.fireErrorToast(data.message);
                        }
                    });
                }
            });
        },
        copyProposalTemplateGroup(proposalTemplateGroup){
            axios.post(route('api.proposal-template-group.copy'), {proposalTemplateGroup: proposalTemplateGroup}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.cancelModalProposalTemplateGroup();
                    this.proposalTemplateGroupList = data.listProposalTemplateGroups;
                    this.selectedProposalTemplateGroupListing = data.proposalTemplateGroup;
                    this.selectProposalTemplateGroup(data.proposalTemplateGroup);
                    this.fetchAllTemplates(data.proposalTemplateGroup);
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        renameTemplateModal(proposalTemplate){
            this.proposalSelectedTemplate = proposalTemplate;
            this.proposalTemplateName = proposalTemplate.template_name;
            $('#templateModal').modal("show");
        },
        cancelModalProposalTemplateRename(){
            this.proposalTemplateName = '';
            this.proposalSelectedTemplate = null;
            this.proposalTemplateNameError = '';
            $('#proposal_template_name').removeAttr("style");
            $('#templateModal').modal("hide");
        },
        updateProposalTemplateName(){
            if(this.proposalTemplateName.trim() == '' || this.proposalTemplateName == null){
                this.fireErrorToast('Please enter proposal section content name.');
                this.proposalTemplateName = '';
                return false;
            }
            axios.post(route('api.proposal-template.rename'), {name:this.proposalTemplateName, proposalSelectedTemplate: this.proposalSelectedTemplate }).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.cancelModalProposalTemplateRename();
                    this.selectProposalTemplateGroup(this.selectedProposalTemplateGroup);
                }else{
                    this.fireErrorToast(data.message);
                    $('#proposal_template_name').css('border', "1px solid red");
                    this.proposalTemplateNameError = data.message;
                }
            });
        },
        deleteTemplate(singleProposalTemplateListing){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal content!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-template.delete'), {proposalSelectedTemplate: singleProposalTemplateListing }).then(({data}) => {
                        if(data.status == 'success'){
                            this.fireSuccessToast(data.message);
                            this.selectProposalTemplateGroup(this.selectedProposalTemplateGroup);
                        }else{
                            this.fireErrorToast(data.message);
                            $('#proposal_template_name').css('border', "1px solid red");
                            this.proposalTemplateNameError = data.message;
                        }
                    });
                }
            });
        },
        copyTemplate(singleProposalTemplateListing){
            axios.post(route('api.proposal-template.copy'), {proposalSelectedTemplate: singleProposalTemplateListing, selectedProposalTemplateGroup:this.selectedProposalTemplateGroup }).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.selectProposalTemplateGroup(this.selectedProposalTemplateGroup);
                }else{
                    this.fireErrorToast(data.message);
                    $('#proposal_template_name').css('border', "1px solid red");
                    this.proposalTemplateNameError = data.message;
                }
            });
        },
        removeTemplateFromGroup(singleProposalTemplateListing){
            axios.post(route('api.proposal-template.remove-from-group'), {proposalSelectedTemplate: singleProposalTemplateListing, selectedProposalTemplateGroup:this.selectedProposalTemplateGroup }).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.selectProposalTemplateGroup(this.selectedProposalTemplateGroup);
                }else{
                    this.fireErrorToast(data.message);
                    $('#proposal_template_name').css('border', "1px solid red");
                    this.proposalTemplateNameError = data.message;
                }
            });
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },
    }
};
</script>

<style>
    button#proposal-template-group-setting__BV_toggle_ {
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
    }

    #proposal-template-group-setting button{
        color: #01b1af !important;
        border-color: #01b1af !important;
    }

    #proposal-template-group-setting button:hover,
    #proposal-template-group-setting button.dropdown-toggle,
    #proposal-template-group-setting button.active,
    .show > .btn-outline-danger.dropdown-toggle{
        color: #fff !important;
        background-color: #01b1af !important;
        border-color: #01b1af !important;
    }

    #proposal-template-group-setting ul.dropdown-menu.show {
        width: 500px;
    }

    .template-single {
        display: block;
        width: 100%;
        background: #fff;
        border-radius: 5px;
        padding: 10px 20px;
    }

    .dropdown-item:hover{
        cursor: pointer;
    }

    .menuDots{
        float:right;
        margin-top: 5px;
    }

    .tempName{
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
    }
</style>
